import Navbar from '../components/Faq/Navbar'
import Sidebar from '../components/Console/Sidebar'
import 'bootstrap/dist/css/bootstrap.min.css';
import React, {useState} from 'react'

import ConsoleFooter from '../components/Console/Footer'
import Content from '../components/Faq/content'
function Faq() {
  const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}
  return (
    <>
      <Sidebar isOpen= {isOpen} toggle={toggle}/>
		  <Navbar toggle={toggle} />
      <Content/>
      <ConsoleFooter />
    </>
  )
}

export default Faq
